import React from 'react';
import TrackThumbnail from "components/TrackThumbnail.js";
import Sample from "repos/Sample.js";
import {getSampleIdsFromSequence} from "utils/getSamplesFromSequence.js"
import Colors from 'components/Colors.js';
import ipfs from 'decentralized/Ipfs.js';
import {isNumber} from 'utils/IsNumber.js';
const colors = new Colors();
const MAX_STEP = 32;

const STEP_WIDTH = 8;

export const getWorkGraphic = async (work, stepWidth=STEP_WIDTH) => {
    let data = {};
    try {
        data = await window.sequencerEngine.encryptedIpfs.getJson(work.newSequence, work.guildId, 5000);
        if (typeof data !== "object") {
            return '';
        }
    } catch (e) {
        console.log("ERROR = ", e);
        return '';
    }

    let samples = await fetchSamples(getSampleIdsFromSequence(data));
    // each entry is a track containing a list of patterns
    // each of these pattern lists contains steps numbers that are ON
    let tracks = [];
    let colors = [];
    for (let i in data.subSequences) {
        tracks = [
            ... tracks,
            ... data.subSequences[i].tracks.map(
                track => track.map(
                    key => Object.keys(key).filter(x => isNumber(x)).map(parseFloat)
                        .filter(step => step < MAX_STEP)))];

        colors = [
            ... colors,
            ... data.subSequences[i].tracksData.map(
                trackData => getColor(
                    trackData.type === 'SAMPLER' ? trackData.samplers :
                        trackData.presetName || trackData.type))
        ];
    }

    let _samples = samples.filter(x => x.getThumbnail());
    // using this create a graphic
    return {graphic: [(
        <div className="bpm">{data.bpm}</div>
    ),
        ...tracks.map( 
            (track, i) =>
                <div
                  key={'track-' + i}
                  className="track-graphic">
              {track[0].map((step, j) =>
                            <div
                              key={i + '-' + step + '-step'}
                              style={{left: step*stepWidth, backgroundColor: colors[i]}}
                              className="step-graphic"></div>)}
                </div>),
                      _samples.length > 0 ? 
                      <div className="work-sounds">
                        {_samples
                         .map(
                          sample => <TrackThumbnail sample={sample}/>)}
                      </div> : ''
                     ],
            bpm: data.bpm,
            wallpaper: data.wallpaper
           };
};

const getColor = (id) => {
    if (typeof id === 'object') {
        id = Object.keys(id)[0];
    }
    if (id === undefined) {
        return undefined;
    }
    return colors.saturate(colors.getColorForHash(id), 3);
};

const fetchSamples = async (s) => {
    let samples = [];
    for (let _s of s) {
        let sample = new Sample(_s);
        await sample.load(false);
        samples.push(sample);
    }
    return samples;
};
